// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3a7mB","options":"AnswerScale_options__2J2SS","selected":"AnswerScale_selected__2f9eQ"};